export function memoizeOne(fn) {
  let lastArg = null;
  let lastResult = null;
  return function (arg) {
    if (lastArg === null || arg !== lastArg) {
      lastArg = arg;
      lastResult = fn(arg);
    }
    return lastResult;
  };
}